import type { EditorThemeClasses } from 'lexical';

export const lexicalMarkdownTheme: EditorThemeClasses = {
  paragraph: 'lexical-paragraph',
  quote: 'lexical-quote',
  heading: {
    h1: 'lexical-heading lexical-heading-h1',
    h2: 'lexical-heading lexical-heading-h2',
    h3: 'lexical-heading lexical-heading-h3',
    h4: 'lexical-heading lexical-heading-h4',
    h5: 'lexical-heading lexical-heading-h5',
    h6: 'lexical-heading lexical-heading-h6',
  },
  list: {
    ol: 'lexical-list lexical-list-ol',
    ul: 'lexical-list lexical-list-ul',
    listitem: 'lexical-list-item',
    nested: {
      listitem: 'lexical-list-item lexical-list-item-nested',
    },
  },
  link: 'lexical-link',
  text: {
    bold: 'lexical-text-bold',
    italic: 'lexical-text-italic',
    strikethrough: 'lexical-text-strikethrough',
    underline: 'lexical-text-underline',
    code: 'lexical-text-code',
  },
};
